export enum LOAN_ACTIONS {
	BACK_TO_HOME,
	RESET_ID_STATUS_AND_BACK_STEP,
	BACK_STEP,
	NEXT_STEP,
	SAVE_FORM_IN_STORAGE,
	SAVE_FORM_IN_SERVICES,
	UPDATE_FORM,
	UPDATE_FORM_WITH_KNOCKOUT,
	UPDATE_FORM_WITH_SCORING_AND_FINISH,
	SAVE_FORM_AND_UPDATE_WITH_KNOCKOUT,
	UPDATE_FORM_WITH_SCORING_SYNC_AND_FINISH,
	SAVE_FORM_AND_CALL_REFINANCING_SERVICE,
}
